"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericConfirmDialog = void 0;
var React = require("react");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericConfirmDialog = function (props) {
    return (React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, header: props.header ||
            (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
            React.createElement(ConfirmDialog_1.Exclamation, null),
            React.createElement("div", null,
                React.createElement("div", { className: 'title please-confirm-text' },
                    React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                React.createElement("div", { className: 'text' },
                    React.createElement("p", null, props.firstRow),
                    React.createElement("p", null, props.secondRow)))), footer: React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Button, { color: props.confirmColor || 'red', text: props.confirmText ||
                    (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                    props.confirm();
                    props.setIsOpen(false);
                } }),
            React.createElement(sok_ui_1.Button, { color: props.cancelColor || 'dark-gray', text: props.cancelText ||
                    (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setIsOpen(false); } })) }));
};
exports.GenericConfirmDialog = GenericConfirmDialog;
